<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-toolbar flat color="transparent" height="50">
          <h3>Quãng đường di chuyển theo xe</h3>
          <v-spacer></v-spacer>
          <v-autocomplete
            box
            height="40"
            label="Chọn xe"
            item-text="plate"
            item-value="id"
            v-model="vehicleId"
            :items="vehicles"
            class="date-picker select-vehicle"
            width="200"
          ></v-autocomplete>
          <v-menu
            :close-on-content-click="false"
            v-model="menu1"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              box
              height="40"
              slot="activator"
              v-model="fromTime"
              label="Từ ngày"
              append-icon="event"
              class="date-picker"
            ></v-text-field>
            <v-date-picker
              v-model="fromTime"
              @input="menu1 = false"
              @change="getDailyReportingSubmit()"
            ></v-date-picker>
          </v-menu>&nbsp;&nbsp;
          <v-menu
            :close-on-content-click="false"
            v-model="menu2"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              box
              height="40"
              slot="activator"
              v-model="toTime"
              label="Đến ngày"
              append-icon="event"
              class="date-picker"
            ></v-text-field>
            <v-date-picker
              v-model="toTime"
              @input="menu2 = false"
              @change="getDailyReportingSubmit()"
            ></v-date-picker>
          </v-menu>
        </v-toolbar>
        <v-flex xs12 sm12 md12 lg12 v-if="dailyReporting.length > 0">
          <e-chart
            :path-option="[
                  [`dataset.source`, chartData],
                  [`color`, [color.lightBlue.base]],
                  //[`legend.show`, true],
                  [`xAxis.axisLabel.show`, true],
                  [`yAxis.axisLabel.show`, true],
                  [`grid.left`, `2%`],
                  [`grid.bottom`, `5%`],
                  [`grid.right`, `3%`],
                  [`series[0].type`, `bar`],
                  [`series[0].areaStyle`, {}],
                  [`series[0].smooth`, true],
                ]"
            height="400px"
            width="100%"
          ></e-chart>
        </v-flex>
        <v-flex xs12 sm12 md12 lg12>
          <table-list
            :isLoading="isLoading"
            :headers="headers"
            :datasource="dailyReporting"
            :exportFilename="`Bao_cao_quang_duong_theo_xe`"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Material from 'vuetify/es5/util/colors';
import TableList from './components/List';
import EChart from '@/components/chart/echart';
import * as Utils from '@/utils';
import * as DateTimeUtil from '@/utils/datetime';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  components: {
    TableList,
    EChart
  },
  data () {
    return {
      color: Material,
      vehicleId: '',
      vehicleDialog: false,
      isLoading: false,
      menu1: false,
      menu2: false,
      fromTime: DateTimeUtil.addDate(new Date(), -30)
        .toISOString()
        .substr(0, 10),
      toTime: new Date().toISOString().substr(0, 10),
      dailyReporting: [],
      headers: [
        {
          text: 'STT',
          value: 'no'
        },
        {
          text: 'Biển số',
          value: 'plate'
        },
        {
          text: 'Ngày',
          value: 'date'
        },
        {
          text: 'Bắt đầu',
          value: 'start'
        },
        {
          text: 'Kết thúc',
          value: 'end'
        },
        {
          text: 'Quãng đường (km)',
          value: 'km'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['vehicles', 'selectedVehicle']),
    chartData () {
      let data = [];
      this.dailyReporting.map(a => {
        let item = {
          date: a.date,
          km: a.km
        };
        data.push(item);
        return 0;
      });
      return data;
    }
  },
  watch: {
    vehicleId () {
      this.SET_SELECTED_VEHICLES(
        this.vehicles.filter(a => a.id === this.vehicleId)[0]
      );
    },
    selectedVehicle () {
      this.getDailyReportingSubmit();
    }
  },
  mounted () {
    if (this.selectedVehicle !== null) {
      this.vehicleId = this.selectedVehicle.id;
      this.getDailyReportingSubmit();
    }
  },
  methods: {
    ...mapActions(['getDailyReporting']),
    ...mapMutations(['SET_SELECTED_VEHICLES']),
    getDailyReportingSubmit () {
      this.isLoading = true;
      this.dailyReporting = [];
      let data = {
        vehicleIds: [this.selectedVehicle.id],
        fromTime: DateTimeUtil.convertDateTimeToSecond2010(this.fromTime),
        toTime: DateTimeUtil.convertDateTimeToSecond2010(this.toTime)
      };
      this.getDailyReporting(data).then(res => {
        let report = [];
        if (res.reports) {
          res.reports.map((a, index) => {
            let item = {
              no: ++index,
              plate: this.selectedVehicle.plate,
              date: DateTimeUtil.formatSecondToYYMMDD(a.time),
              start: DateTimeUtil.formatSecondToHHmm(a.firstTime),
              end: DateTimeUtil.formatSecondToHHmm(a.lastTime),
              km: a.km.toFixed(2)
            };
            report.push(item);
            return 0;
          });

          this.dailyReporting = report;
          this.isLoading = false;
        }
      });
    }
  }
};
</script>
<style scoped>
.left {
  width: calc(100% - 400px);
  height: calc(100vh - 64px);
}
.right {
  width: 400px;
}
</style>
<style>
.date-picker {
  margin-top: 8px !important;
}
.select-vehicle {
  margin-right: 8px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/reporting/DailyByVehicle.vue